import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MedicoPacientesComponent } from './subpages/medico-pacientes/medico-pacientes.component';
import { MedicoCadastrarPacienteComponent } from './subpages/medico-cadastrar-paciente/medico-cadastrar-paciente.component';
import { MedicoEditarPerfilComponent } from './subpages/medico-editar-perfil/medico-editar-perfil.component';
import { MedicoAlterarPacienteComponent } from './subpages/medico-alterar-paciente/medico-alterar-paciente.component';
import { MedicoAlterarCartaoGestanteComponent } from './subpages/medico-alterar-cartao-gestante/medico-alterar-cartao-gestante.component';
import { RoleGuard } from 'app/core/guards/role.guard';
import { MedicoSecretariasComponent } from './subpages/medico-secretarias/medico-secretarias.component';

const routes: Routes = [
  {
    path: 'medico', 
    component: MedicoPacientesComponent, 
    canActivate: [RoleGuard],
    data: { roles: ['medico'] }
  },
  {
    path: 'medico-cadastrar-pacientes', 
    component: MedicoCadastrarPacienteComponent,
    canActivate: [RoleGuard],
    data: { roles: ['medico'] }
  },
  {
    path: 'medico-alterar-pacientes', 
    component: MedicoAlterarPacienteComponent,
    canActivate: [RoleGuard],
    data: { roles: ['medico'] }
  },
  {
    path: 'medico-alterar-cartao-gestante', 
    component: MedicoAlterarCartaoGestanteComponent,
    canActivate: [RoleGuard],
    data: { roles: ['medico'] }
  },
  {
    path: 'medico-editar-perfil', 
    component: MedicoEditarPerfilComponent,
    canActivate: [RoleGuard],
    data: { roles: ['medico'] }
  },
  {
    path: 'medico-secretarias', 
    component: MedicoSecretariasComponent,
    canActivate: [RoleGuard],
    data: { roles: ['medico'] }
  },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class MedicoRoutingModule { }
